import {
	IN_APP_JOIN_BROADCAST,
	IN_APP_LEAVE_BROADCAST,
	IN_BREAKOUT_ROOM_MOVE_BROADCAST,
	IN_BREAKOUT_ROOM_ALLOW_SPEAK_BROADCAST,
	IN_ROOM_CREATE_BROADCAST,
	IN_UPDATE_ROOM_BROADCAST,
	IN_ROOM_DELETE_BROADCAST,
	IN_JOIN_ROOM_BROADCAST,
	IN_LEAVE_ROOM_BROADCAST,
	IN_WHITEBOARD_UPDATE_BROADCAST,
	IN_WHITEBOARD_ACTIVE_BROADCAST,
	IN_EMOJI_BROADCAST,
	IN_REACTION_BROADCAST,
	IN_EMOJI_WEBINAR_BROADCAST,
	IN_END_ROOM_BROADCAST,
	IN_KICK_RESPONSE,
	IN_BREAKOUT_ROOM_UPDATE_BROADCAST,
	IN_BREAKOUT_ASSIGN_ID_BROADCAST,
	IN_ROOM_RECORDING_BROADCAST,
	IN_ROOM_ADMIT_RESPONSE,
	IN_ROOM_UPDATE_SETTINGS_BROADCAST,
	IN_BREAKOUT_ROOM_AUTO_ASSIGN_BROADCAST,
	IN_BREAKOUT_ROOM_TIME_EXTEND_BROADCAST,
	IN_CHAT_BROADCAST,
	IN_ROOM_ACTIVE_CHAT_BROADCAST,
	IN_BREAKOUT_ROOM_REMOVE_BROADCAST,
	IN_BREAKOUT_ROOM_OPEN_BROADCAST,
	IN_JOIN_WAITING_ROOM_BROADCAST,
	IN_ROOM_ACTIVE_CC_BROADCAST
} from './constant';
import * as appActions from '../../stores/actions/appActions';
import * as alertActions from '../../stores/actions/alertActions';
import * as authActions from '../../stores/actions/authActions';
import * as roomsActions from '../../stores/actions/roomsActions';
import * as peerActions from '../../stores/actions/peerActions';
import * as roomActions from '../../stores/actions/roomActions';
import * as chatActions from '../../stores/actions/chatActions';
import * as intlActions from '../../stores/actions/intlActions';
import * as breakoutRoomsActions from '../../stores/actions/breakoutRoomsActions';
import * as locales from '../translations/locales';
import { createIntl } from 'react-intl';
import { toast } from 'react-toastify';
import { signOut } from '../../api/general/auth/email';
import { userRoles } from '../constants';
import { HOME_PATH } from '../routes';

let io;

let store;

let intl;

export default class NetplaSocket
{
	static init(data)
	{
		store = data.store;
	}

	constructor()
	{
		this.reconnectionAttempts = 0;
		this.maxReconnectionAttempts = 3;
		this.closed = true;
		this.signalingUrl = null;
		this.setLocale(store.getState().intl.locale);
	}

	setLocale(locale)
	{
		if (locale === null) locale = locales.detect();

		const one = locales.loadOne(locale);

		store.dispatch(
			intlActions.updateIntl({
				locale: one.locale[0],
				messages: one.messages,
				list: locales.getList()
			})
		);

		intl = createIntl({
			locale: store.getState().intl.locale,
			messages: store.getState().intl.messages
		});

		document.documentElement.lang = store.getState().intl.locale.toUpperCase();
	}

	async close()
	{
		this.closed = true;
		this.signalingSocket?.off();
		this.signalingSocket?.close();
		this.signalingSocket = null;
	}

	async sendRequest(type, data)
	{
		if (this.signalingSocket)
		{
			this.signalingSocket.emit(type, data);
		}
	}

	async loadDynamicImports()
	{
		({ default: io } = await import(

			/* webpackPrefetch: true */
			/* webpackChunkName: "socket.io" */
			'socket.io-client'
		));
	}

	async connect()
	{
		await this.loadDynamicImports();

		this.close();
		this.signalingSocket = io(process.env.REACT_APP_BACKEND_PROXY_TARGET, {
			transports: ['websocket'],
			reconnection: false,
			secure: true,
			rejectUnauthorized: false,
			forceNew: true
		});

		this.signalingSocket.on('connect_error', () =>
		{
			setTimeout(() =>
			{
				console.log('Reconnection attempt');
				this.connect();
			}
			, 4000);
		});

		this.signalingSocket.on('connect', async () =>
		{
			this.reconnectionAttempts = 0; // Reset attempts on successful connection
			store.dispatch(appActions.setDuplicatedStatus(false));
			console.log('signaling user "connect" event');
		});

		this.signalingSocket.on('connected', async () =>
		{
			this.closed = false;
			console.log('signaling user "connected" event');
			store.dispatch(appActions.setConnectStatus(true));
		});

		this.signalingSocket.on('disconnect', (reason) =>
		{
			const title = intl.formatMessage({
				id: 'socket.disconnect.title',
				defaultMessage: 'Lost Network Connection'
			});
			const description = intl.formatMessage({
				id: 'socket.disconnect.description',
				defaultMessage: 'Your network connections was interrupted, \n Please click rejoin to reconnect to the network'
			});
			const okTitle = intl.formatMessage({
				id: 'label.reload',
				defaultMessage: 'Rejoin'
			});

			console.log('signaling user "disconnect" event [reason:"%s"]', reason);
			store.dispatch(appActions.setConnectStatus(false));

			setTimeout(() =>
			{
				const duplicated = store.getState().app.isDuplicated;

				if (!duplicated)
				{
					if (this.reconnectionAttempts < this.maxReconnectionAttempts)
					{
						this.reconnectionAttempts += 1;
						console.log(`Reconnection attempt ${this.reconnectionAttempts}...`);
						this.connect();
					}
					else
					{
						console.error('Max reconnection attempts reached');
						this.close();
						store.dispatch(alertActions.setAlert({ title,
							description,
							okTitle,
							type: 'error',
							disableClose: true,
							onOk: () => window.location.reload()
						}));
					}
				}
			}
			, 4000);

		});

		this.signalingSocket.on('duplicated', () =>
		{
			const title = intl.formatMessage({
				id: 'socket.duplicated.title',
				defaultMessage: 'Duplicated Login Detected'
			});
			const description = intl.formatMessage({
				id: 'socket.duplicated.description',
				defaultMessage: 'A session with these credentials is already active. Please click <b>Rejoin</b> to join from this session or <b>x</b> to close this page.'
			},
			{
				b: (chunks) => <b>{chunks}</b>
			});
			const okTitle = intl.formatMessage({
				id: 'label.reload',
				defaultMessage: 'Rejoin'
			});

			this.close();
			store.dispatch(appActions.setDuplicatedStatus(true));
			store.dispatch(appActions.setConnectStatus(false));
			store.dispatch(alertActions.setAlert({ title,
				description,
				okTitle,
				type: 'error',
				disableClose: true,
				onOk: () => window.location.reload(),
				onCancel: async () =>
				{
					try
					{
						await signOut();
						store.dispatch(authActions.signOutSuccess());
					}
					catch (err)
					{
						store.dispatch(authActions.signOutSuccess());
					}
					finally
					{
						window.location.href = HOME_PATH;
					}
				} }));
		});

		this.signalingSocket.on('reconnectfailed', () =>
		{
			console.log('signaling Peer "reconnectfailed" event');
			store.dispatch(appActions.setConnectStatus(false));
			this.close();
		});

		this.signalingSocket.on('reconnect', (attemptNumber) =>
		{
			console.log(
				'signaling Peer "reconnect" event [attempts:"%s"]',
				attemptNumber
			);
		});

		this.signalingSocket.on('messages', async (request) =>
		{
			const { user } = store.getState().auth;

			console.log(
				'app socket "request" event [method:"%s", data:"%o"]',
				request.type,
				request.payload
			);

			switch (request.type)
			{
				case IN_APP_JOIN_BROADCAST: {
					const { user } = request.payload;

					store.dispatch(appActions.appJoinRequest(user));
					break;
				}
				case IN_ROOM_ACTIVE_CHAT_BROADCAST: {
					const { roomId, activeChat } = request.payload;

					store.dispatch(roomActions.setActiveChat(roomId, activeChat));
					break;
				}

				case IN_ROOM_ACTIVE_CC_BROADCAST: {
					const room = store.getState().room;
					const { roomId, closedCaption } = request.payload;

					if (roomId === room.id)
					{
						if (closedCaption)
						{
							toast(intl.formatMessage({
								id: 'message.closedCaption.update',
								defaultMessage: 'Closed caption is active in the room.'
							}));
						}
						store.dispatch(roomActions.setActiveCC(closedCaption));
					}

					break;
				}

				case IN_CHAT_BROADCAST: {
					const { roomId, text, sender, time } = request.payload;
					const room = store.getState().room;

					if (room.id === roomId)
					{
						const newMessageNotification = !room.openChat && sender.id !== user?.id;

						if (newMessageNotification)
						{
							toast(intl.formatMessage({
								id: 'message.notification.new',
								defaultMessage: 'New message arrived from {sender}'
							},
							{
								sender: sender.name
							})
							);
						}
						store.dispatch(chatActions.addUserMessage({ text, sender, time, isNewMessage: newMessageNotification ?? undefined }));
					}

					break;
				}
				case IN_APP_LEAVE_BROADCAST: {
					const { userId } = request.payload;
					const breakoutRooms = store.getState().breakoutRooms;
					const user = store.getState().auth.user;

					if (userId !== user?.id)
					{
						store.dispatch(appActions.appLeaveRequest(userId));

						store.dispatch(roomsActions.removeUserFromRoom(userId));
						store.dispatch(breakoutRoomsActions.leaveBreakoutRoom(userId));
						store.dispatch(roomActions.removeUsersFromWaiting(userId));

						const users = breakoutRooms.users.filter((bu) => bu.id !== userId);

						store.dispatch(breakoutRoomsActions.updateRoomUsers(users));
					}

					break;
				}
				case IN_BREAKOUT_ROOM_MOVE_BROADCAST: {
					const { userId, shortId, webinar } = request.payload;
					const { user } = store.getState().auth;
					const breakoutRooms = store.getState().breakoutRooms.rooms;

					if (user?.id === userId)
					{
						const title = intl.formatMessage({ id: 'meeting.breakoutRooms', defaultMessage: 'Breakout Rooms' });
						const description = intl.formatMessage({ id: 'meeting.breakoutRooms.moveRequest', defaultMessage: 'The host has moved you to "{breakoutRoom}".' }, { breakoutRoom: breakoutRooms?.find((el) => el.shortId === shortId)?.title });
						const okTitle = intl.formatMessage({ id: 'label.join', defaultMessage: 'Join Now' });

						store.dispatch(alertActions.setAlert({ title, description, okTitle, type: 'info', onOk: () => { window.location.href = `/${webinar ? 'webinar' : 'meeting'}/${shortId}`; } }));
					}

					break;
				}

				case IN_ROOM_RECORDING_BROADCAST: {
					const { roomId, recording } = request.payload;
					const room = store.getState().room;

					if (room.name === roomId)
					{
						store.dispatch(roomActions.setRoomRecordingStatus(recording));
					}

					break;
				}

				case IN_BREAKOUT_ROOM_ALLOW_SPEAK_BROADCAST: {
					const { userId, shortId } = request.payload;
					const { user } = store.getState().auth;

					if (user?.id === userId)
					{
						window.location.href = `/meeting/${shortId}`;
					}

					break;
				}

				case IN_WHITEBOARD_ACTIVE_BROADCAST: {
					const { roomId, active, whiteboard } = request.payload;
					const room = store.getState().room;

					if (room.name === roomId)
					{
						store.dispatch(roomActions.setActiveWhiteboard(active));
						store.dispatch(roomActions.setRoomWhiteboardSketch(whiteboard));
					}

					break;
				}

				case IN_EMOJI_BROADCAST: {
					const { roomId, emoji, peerId } = request.payload;
					const room = store.getState().room;

					if (room.name === roomId)
					{
						store.dispatch(peerActions.setPeerEmoji(peerId, emoji));
					}

					break;
				}

				case IN_EMOJI_WEBINAR_BROADCAST: {
					const { roomId, emoji } = request.payload;
					const room = store.getState().room;

					if (room.name === roomId)
					{
						store.dispatch(roomActions.setEmojiWebinar(emoji));
					}

					break;
				}

				case IN_REACTION_BROADCAST: {
					const { roomId, reaction, peerId } = request.payload;
					const room = store.getState().room;

					if (room.name === roomId)
					{
						store.dispatch(peerActions.setPeerReaction(peerId, reaction));
					}

					break;
				}

				case IN_WHITEBOARD_UPDATE_BROADCAST: {
					const { roomId, whiteboard } = request.payload;
					const room = store.getState().room;

					if (room.name === roomId)
					{
						store.dispatch(roomActions.setRoomWhiteboardSketch(whiteboard));
					}

					break;
				}

				case IN_ROOM_CREATE_BROADCAST: {
					const { room } = request.payload;

					if (room.adminId !== user?.id)
					{
						if (!room.parentId)
						{
							store.dispatch(roomsActions.addRoom(room));
						}
						else
						{
							store.dispatch(breakoutRoomsActions.addBreakoutRoom(room));
						}
					}

					break;
				}
				case IN_UPDATE_ROOM_BROADCAST: {
					const { room } = request.payload;

					if (room.adminId !== user?.id)
					{
						store.dispatch(roomsActions.updateRoom(room));
					}

					break;
				}

				case IN_ROOM_UPDATE_SETTINGS_BROADCAST: {
					const { setting, roomId } = request.payload;
					const breakoutRooms = store.getState().breakoutRooms;
					const me = store.getState().me;
					const isHost = me.roles.some((peerRole) => peerRole === userRoles.MODERATOR) || user?.type === 'super-admin';

					if (user?.room?.id === roomId || user?.room.parentId === roomId)
					{
						if (isHost)
						{
							toast(intl.formatMessage({
								id: 'socket.breakout.update',
								defaultMessage: 'Updated Breakout Room Settings'
							}));
						}

						store.dispatch(breakoutRoomsActions.updateBreakoutRoomSettings({ ...breakoutRooms.settings, ...setting }));
					}

					break;
				}

				case IN_ROOM_DELETE_BROADCAST: {
					const { roomId } = request.payload;
					const room = store.getState().room;

					store.dispatch(roomsActions.removeRoom(roomId));
					store.dispatch(breakoutRoomsActions.removeBreakoutRoom(roomId));

					if (room.id === roomId || room.parentId === roomId)
					{
						store.dispatch(roomActions.setRoomForceClose());
					}

					break;
				}
				case IN_KICK_RESPONSE: {
					const { roomId, userId } = request.payload;
					const me = store.getState().me;
					const room = store.getState().room;

					if (me.userId === userId)
					{
						store.dispatch(roomsActions.removeRoom(roomId));
						store.dispatch(breakoutRoomsActions.removeBreakoutRoom(roomId));

						if (room.id === roomId || room.parentId === roomId)
						{
							store.dispatch(roomActions.setRoomKicked());
						}
					}

					break;
				}
				case IN_ROOM_ADMIT_RESPONSE: {
					const { roomId, userId } = request.payload;
					const user = store.getState().auth.user;

					if (user?.id === userId && user?.room?.id === roomId)
					{
						store.dispatch(authActions.updateAdmittedStatus(true));
					}
					break;
				}
				case IN_JOIN_ROOM_BROADCAST: {
					const { roomId, admitted, user, waitingUsers } = request.payload;
					const authUser = store.getState().auth.user;
					const breakoutRooms = store.getState().breakoutRooms;

					if (user?.type === 'recording-bot') return;

					if (user?.id === authUser.id && authUser?.room?.id === roomId)
					{
						store.dispatch(authActions.updateAdmittedStatus(admitted));
					}

					store.dispatch(roomActions.removeUsersFromWaiting(user?.id));
					store.dispatch(roomsActions.joinUserIntoRoom(user, roomId));
					store.dispatch(breakoutRoomsActions.joinBreakoutRoom(user, roomId));

					if (breakoutRooms.rooms.some((el) => el.id === roomId))
					{
						const users = breakoutRooms.users.filter((bu) => bu.id !== user?.id);

						store.dispatch(breakoutRoomsActions.updateRoomUsers(users));
					}
					else
					{
						const users = [ ...breakoutRooms.users.filter((bu) => bu.id !== user?.id), user ];

						store.dispatch(breakoutRoomsActions.updateRoomUsers(users));
					}

					store.dispatch(roomActions.setUsersIntoWaiting(roomId, waitingUsers));
					break;
				}
				case IN_JOIN_WAITING_ROOM_BROADCAST: {
					const { roomId, user } = request.payload;

					store.dispatch(roomActions.addUserIntoWaiting(roomId, user));
					break;
				}
				case IN_LEAVE_ROOM_BROADCAST: {
					const { userId } = request.payload;
					const breakoutRooms = store.getState().breakoutRooms;

					store.dispatch(roomsActions.removeUserFromRoom(userId));
					store.dispatch(breakoutRoomsActions.leaveBreakoutRoom(userId));
					store.dispatch(roomActions.removeUsersFromWaiting(userId));

					const users = breakoutRooms.users.filter((bu) => bu.id !== userId);

					store.dispatch(breakoutRoomsActions.updateRoomUsers(users));
					break;
				}
				case IN_END_ROOM_BROADCAST: {
					const { roomId } = request.payload;
					const room = store.getState().room;

					if (room.id === roomId || room.parentId === roomId)
					{
						store.dispatch(roomActions.setRoomForceClose());
					}

					break;
				}
				case IN_BREAKOUT_ROOM_UPDATE_BROADCAST: {
					const { id, title } = request.payload;
					const { rooms } = store.getState().breakoutRooms;

					store.dispatch(breakoutRoomsActions.setBreakoutRooms(rooms.map((el) => (el.id === id ? ({ ...el, title }) : el))));
					break;
				}
				case IN_BREAKOUT_ROOM_TIME_EXTEND_BROADCAST: {
					const { timeLimit, parentId } = request.payload;
					const room = store.getState().room;

					if (room.parentId === parentId)
					{
						store.dispatch(roomActions.setTimeLimit(timeLimit));
						toast(intl.formatMessage({
							id: 'socket.breakout.update.timeExtended',
							defaultMessage: 'Breakout room time was extended.'
						}));
					}
					break;
				}
				case IN_BREAKOUT_ASSIGN_ID_BROADCAST: {
					const { roomId, userId, breakoutRoomId, shortId, webinar } = request.payload;
					const room = store.getState().room;
					const user = store.getState().auth.user;
					const breakoutRooms = store.getState().breakoutRooms.rooms;

					if (room.id === roomId || room.parentId === roomId)
					{
						if (user?.id === userId)
						{
							if (room.parentId && !breakoutRoomId)
							{
								// When the user joined into breakout room and get unassign request, remove from room.
								window.location.href = `/${webinar ? 'webinar':'meeting'}/${shortId}`;
								break;
							}

							const breakoutRoom = breakoutRooms.find((bo) => bo.id === breakoutRoomId)?.title;

							if (breakoutRoom)
							{
								toast(intl.formatMessage({
									id: 'socket.breakout.assign',
									defaultMessage: 'You have been assigned to breakout room "{breakoutRoom}"'
								},
								{ breakoutRoom }));
							}
							else
							{
								toast(intl.formatMessage({
									id: 'socket.breakout.unassign',
									defaultMessage: 'You have been unassigned from breakout room.'
								}));
							}
						}

						store.dispatch(breakoutRoomsActions.updateRoomUsersAssignBreakoutRoom(userId, breakoutRoomId));
					}

					break;
				}
				case IN_BREAKOUT_ROOM_REMOVE_BROADCAST: {
					const { userId, shortId, webinar } = request.payload;

					if (user?.id === userId && user?.room.shortId !== shortId)
					{
						window.location.href = `/${webinar ? 'webinar':'meeting'}/${shortId}`;
					}

					break;
				}
				case IN_BREAKOUT_ROOM_AUTO_ASSIGN_BROADCAST: {
					const { breakoutRoomUsers } = request.payload;

					for (let i = 0; i < breakoutRoomUsers.length; i ++)
					{
						store.dispatch(breakoutRoomsActions.updateRoomUsersAssignBreakoutRoom(breakoutRoomUsers[i].userId, breakoutRoomUsers[i].roomId));
					}
					break;
				}
				case IN_BREAKOUT_ROOM_OPEN_BROADCAST: {
					const { roomId, open, shortId, webinar, startTime } = request.payload;
					const room = store.getState().room;
					const user = store.getState().auth.user;
					const breakoutRoomUsers = store.getState().breakoutRooms.users;
					const breakoutRooms = store.getState().breakoutRooms.rooms;
					const settings = store.getState().breakoutRooms.settings;

					if (roomId === room.id || room.parentId === roomId)
					{
						if (open)
						{
							store.dispatch(breakoutRoomsActions.updateBreakoutRoomSettings({ ...settings, activeBO: open }));

							if (room.parentId === roomId)
							{
								store.dispatch(roomActions.setStartTime(startTime));
							}

							const breakoutRoomUser = breakoutRoomUsers.find((bou) => Boolean(bou.assignedRoom) && bou.id === user?.id);

							if (breakoutRoomUser)
							{
								const assignedRoom = breakoutRooms.find((bo) => bo.id === breakoutRoomUser.assignedRoom);

								window.location.href = `/${webinar?'webinar':'meeting'}/${assignedRoom.shortId}`;
							}
						}
						else if (roomId !== room.id)
						{
							window.location.href = `/${webinar?'webinar':'meeting'}/${shortId}`;
						}
					}

					break;
				}
				default: {
					console.log('unknown request.method "%s"', request.type);
				}
			}
		});
	}
}